
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form16DataInfoType } from '@/types/Information/Form16';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox,
        UnderlineForm,          
    }
})
export default class Form16Layout extends Vue {

    @Prop({required:true})
    result!: form16DataInfoType;
}

